module.exports = __webpack_public_path__ + "img/logo@2x.9eba66ad.png";